import React from 'react';

interface ClientDetailStatsProps {
  stats: {
    total: number;
    completed: number;
    cancelled: number;
    upcoming: number;
    last_booking_at: string | null;
  };
}

const ClientDetailStats: React.FC<ClientDetailStatsProps> = ({ stats }) => {
  const formatDate = (dateString: string | null) => {
    if (!dateString) return 'Never';
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  };

  const statItems = [
    { label: 'Total Bookings', value: stats.total, color: 'text-gray-900' },
    { label: 'Completed', value: stats.completed, color: 'text-green-600' },
    { label: 'Upcoming', value: stats.upcoming, color: 'text-blue-600' },
    { label: 'Cancelled', value: stats.cancelled, color: 'text-red-600' },
  ];

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-6">
      <h2 className="text-sm font-semibold uppercase tracking-wide text-gray-500 mb-4">
        Statistics
      </h2>
      <div className="grid grid-cols-2 gap-4">
        {statItems.map((item) => (
          <div key={item.label}>
            <p className="text-xs text-gray-500">{item.label}</p>
            <p className={`text-2xl font-bold ${item.color}`}>{item.value}</p>
          </div>
        ))}
      </div>
      <div className="mt-4 pt-4 border-t border-gray-100">
        <p className="text-xs text-gray-500">Last Booking</p>
        <p className="text-sm font-medium text-gray-900">{formatDate(stats.last_booking_at)}</p>
      </div>
    </div>
  );
};

export default ClientDetailStats;
